import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { promotionService } from "services/promotionService";
import { userService } from "services/userService";
import { RootState } from "store";
import { setPointUsed } from "store/apps/price";
import { errorAlert, successAlert } from "utils/alertHandler";

export default function useCheckoutPromotion() {
  const { user } = useSelector((state: RootState) => state.auth);
  const { pointUsed , discountedPrice } = useSelector((state: RootState) => state.price);

  const [points, setPoints] = useState<number>(pointUsed);

  const [pointInfo, setPointInfo] = useState();
  const [userAccountPointBalance, setUserAccountPointBalance] = useState();
  const [isRedeemPointLoading, setIsRedeemPointLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const _onRedeemPoint = async (): Promise<void> => {
    try {
      setIsRedeemPointLoading(true);

      const unitPrice = Number(pointInfo?.["unit_price"]);
      const redeemAmount = Number(points) / unitPrice;
      const currentPrice = Number(discountedPrice);

      if (!Number.isFinite(points) || points <= 0) {
        throw new Error("Invalid point usage.");
      }

      if (!Number.isFinite(unitPrice) || unitPrice <= 0) {
        throw new Error("Point information is not available.");
      }

      if (points % unitPrice !== 0) {
        throw new Error("Points must be a multiple of the unit price.");
      }

      if (!Number.isFinite(currentPrice) || redeemAmount > currentPrice) {
        throw new Error("Redeem amount exceeds the current price.");
      }

      const latestPoints = await userService.getUserPoints();

      if (!latestPoints) throw new Error("Point Not Found.");

      if (Number(latestPoints.total) < points) throw new Error("Member point is not updated.");

      dispatch(setPointUsed(points));

      successAlert("Redeemed!");

      setIsRedeemPointLoading(false);
    } catch (error: any) {
      errorAlert(error.message);
      setIsRedeemPointLoading(false);
    }
  };

  useEffect(() => {
    if (!user) return;

    (async function () {
      const promoInfo = await promotionService.getOrganizationPoint();

      const userPoint = await userService.getUserPoints();

      if (userPoint) {
        setUserAccountPointBalance(userPoint["total"]);
      }

      if (promoInfo) {
        setPointInfo(promoInfo);
      }
    })();
  }, [user]);

  return { points, pointUsed, pointInfo, userAccountPointBalance, isRedeemPointLoading, setPoints, _onRedeemPoint };
}
